import { Dictionary } from './types'

export const mapDictionaryForResponse = (raw: any): Dictionary => ({
  ...raw.data,
  id: raw.data.id,
  key: raw.data.key,
  value: raw.data.value,
  languageCode: raw.data.languageCode,
})
